<script>
import Modal from './Modal.svelte'
import { createEventDispatcher } from "svelte";
export let buttonText = 'Continue';
export let allowClose = true;
export let showModal;
  let dispatch = createEventDispatcher();
</script>

<Modal bind:showModal={showModal} bind:allowClose={allowClose}>
  <slot/>
  <footer class="modal-card-foot buttons is-right" slot="footer">
    <button
      class="button is-primary continue"
      on:click={() => {
        showModal = false;
        dispatch('continue');
        }}>
     {buttonText}
    </button>
  </footer>
</Modal>